// components/Differentiator.js (actualizado)
import React from 'react';
import ScrollAnimation from './ScrollAnimation';

const Differentiator = () => {
    return (
        <section className="py-16 bg-white">
            <div className="container mx-auto px-6">
                <ScrollAnimation>
                    <h2 className="text-3xl font-bold font-poppins text-grafito mb-8 text-center">Nuestro diferencial</h2>
                </ScrollAnimation>
                <div className="max-w-4xl mx-auto">
                    <ScrollAnimation delay={0.2}>
                        <p className="text-lg text-grafito font-lato mb-6">
                            Combinamos expertise técnico con conocimiento profundo de la gestión pública.
                        </p>
                    </ScrollAnimation>
                    <ScrollAnimation delay={0.4}>
                        <p className="text-lg text-grafito font-lato mb-6">
                            Esa doble mirada nos permite diseñar soluciones realistas, escalables y ajustadas a los marcos normativos y administrativos de cada nivel estatal.
                        </p>
                    </ScrollAnimation>
                    <ScrollAnimation delay={0.6}>
                        <blockquote className="border-l-4 border-cyan pl-4 italic text-xl text-grafito font-lato bg-gray-50 p-6 rounded-r-lg">
                            "No solo programamos sistemas: entendemos la lógica del servicio público y diseñamos tecnología que la potencia."
                        </blockquote>
                    </ScrollAnimation>
                </div>
            </div>
        </section>
    );
};

export default Differentiator;
